import React from "react";
import "../App.css";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import Verification from "./VerifyPayments";
import Entry from "./Entry";
import TigoPesa from "./tigoListener";
import ResetPassword from "./resetPassword";
import Request from "./deleteAccount";

function Home() {
  return (
    <Router>
      <div className="allHeader">
        <p style={{ fontWeight: "bold", fontSize: 25 }}>Tumwabudu Mungu Wetu</p>
      </div>

      <Switch>
        <Route path="/" exact component={Entry} />
        <Route path="/verify/:token" component={Verification} />
        <Route path="/tigo" component={TigoPesa} />
        <Route path="/request" component={Request} />
        <Route path="/resetpassword/:userToken" component={ResetPassword} />
      </Switch>
    </Router>
  );
}

export default Home;
